module.exports = __webpack_public_path__ + "img/label-sync.6e841f26.gif";